import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BsCashCoin } from "react-icons/bs";
import { MdOutlineAirplanemodeActive } from "react-icons/md";
import { IoBriefcaseSharp } from "react-icons/io5";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaInfinity } from "react-icons/fa";
import { GiTavernSign } from "react-icons/gi";
import { Helmet } from "react-helmet";
import { FaBriefcase, FaRegSmileBeam } from "react-icons/fa";
import { MdCardMembership } from "react-icons/md"; // Optional for lifestyle
import {
  FaTasks,
  FaUsers,
  FaChartLine,
  FaGift,
  FaCreditCard,
  FaShieldAlt,
} from "react-icons/fa";
import { CreditCard, TrendingUp, Wallet } from 'lucide-react';
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}
const CreditCardPage = () => {
  useEffect(() => {
    const img = new Image();
    img.src = "https://analytics.bidbox.ai/tracking/segment?key=izi2udb";
  }, []);
  const [activeIndex, setActiveIndex] = useState(0);
  const [CreditCardData, setCreditCardData] = useState([]);

  const faqs = [
    {
      question: "What are the different types of credit cards?",
      answer:
        "Absolutely! Credit cards come in various categories to suit your spending. Cashback cards give you a percentage of your spending back in cash, while travel cards focus on perks for frequent flyers. Premium cards offer top-tier benefits but come with annual fees. There are even cards with gas station benefits! Explore these options to find the perfect card for you.",
    },
    {
      question: "Can we apply for a credit card through TheFinMaster.com?",
      answer:
        " TheFinMaster.com does not directly process credit card applications. We provide information and comparison tools to help you choose the right card. Once you have selected a card, you will be directed to the issuers website to complete a secure application process.",
    },
    {
      question: "What are the eligibility requirements for these credit cards?",
      answer:
        "Eligibility requirements vary depending on the credit card issuer and specific card.  Look for details on the issuers website or by clicking on the card for more information.  Generally, eligibility factors include credit score, income, and employment history.",
    },
    {
      question: "What are the charges for credit cards? ",
      answer:
        "Not always! While some cards have no annual fees, others do. There may also be fees for things like balance transfers, foreign transactions, or late payments. Explore the details of each card before applying.",
    },
    {
      question: "How do I choose the right credit card for my needs?",
      answer:
        "To choose the right card, assess your spending habits, lifestyle, and financial goals. Whether you travel frequently, prefer cashback, or want fuel benefits, select a card that aligns with your primary use and offers maximum rewards.",
    },
    {
      question: "What is a credit limit and how is it decided?",
      answer:
        " A credit limit is the maximum amount you can spend using your credit card. It is determined by the bank based on your income, credit score, repayment history, and financial profile. Responsible usage can lead to limit increases.",
    },
    {
      question: "Does owning a credit card affect my credit score? ",
      answer:
        " Yes, a credit card impacts your credit score. Timely repayments improve your score, while late payments or overutilization can lower it. Maintaining a low credit utilization ratio and paying dues on time is key.",
    },
    {
      question: "What is the difference between a secured and unsecured credit card? ",
      answer:
        " A secured credit card is issued against a fixed deposit and is ideal for those with low or no credit history. Unsecured cards are issued based on income and credit score without any collateral.",
    },
    {
      question: "How do credit card reward points work? ",
      answer:
        " Every time you use your credit card, you earn reward points based on the spend category. These points can be redeemed for travel bookings, gift vouchers, merchandise, or cashback, depending on the card provider’s reward catalogue.",
    },
    {
      question: "Can I convert my credit card purchases into EMIs?",
      answer:
        " Yes, many credit cards offer EMI conversion for large purchases. You can convert eligible transactions into EMIs at a fixed interest rate and tenure. This helps in better financial planning with reduced monthly outgo.",
    },
    {
      question: "Is there a penalty for missing a credit card payment?",
      answer:
        " Yes, missing a payment may lead to late fees, interest charges, and a drop in your credit score. Continued defaults can lead to account suspension and collection calls. Always try to pay at least the minimum due.",
    },
    {
      question: "What is a grace period in credit card billing? ",
      answer:
        "The grace period is the interest-free duration between the billing date and the payment due date, usually 20–25 days. If the outstanding amount is paid within this period, no interest is charged.",
    },
    {
      question: "Can I have multiple credit cards? ",
      answer:
        " Yes, you can hold multiple credit cards, provided you manage them responsibly. It can help diversify benefits and boost your credit score if used wisely. However, it’s important to avoid excessive debt and track all payment dates.",
    },
    {
      question: "What are the charges for credit cards? ",
      answer:
        "Not always! While some cards have no annual fees, others do. There may also be fees for things like balance transfers, foreign transactions, or late payments. Explore the details of each card before applying.",
    },
    {
      question: "What should I do if I lose my credit card? ",
      answer:
        "Immediately block the card through your bank’s mobile app or customer service to prevent unauthorized transactions. Then, request a replacement card. Most banks offer zero liability protection for fraud reported promptly.",
    },
    {
      question: "Can I increase the credit limit on my card? ",
      answer:
        " Yes, you can request a credit limit increase based on your usage and repayment track record. Some banks offer automatic increases, while others require income proof or a formal application for review.",
    },
    {
      question: "Are credit cards accepted internationally? ",
      answer:
        " Most credit cards are internationally accepted if they are enabled for global use. However, foreign currency transaction fees may apply. Inform your bank before traveling abroad to avoid card blocking due to suspicious activity.",
    },
    {
      question: "How can I track my credit card expenses? ",
      answer:
        " You can track expenses through your monthly statement, bank app, or SMS alerts. Setting up payment reminders and budgeting tools can help in managing spends efficiently and avoiding debt traps.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  // useEffect(()=>{
  //     Http.post(CARD_API).then((res)=>{
  //       console.log({res})
  //         setCreditCardData(res)
  //     }).catch((err)=>{
  //         console.log(err)
  //     })
  // },[])

  // CreditCardData.length >0 &&CreditCardData.cards.filter((details)=>{ return details.category === 'Credit card'})
  // console.log("CreditCardData CreditCardData", CreditCardData)
  const cardDataS = [
    {
      imageUrl: "/assets/Au1.webp",
      title: "AU Bank LIT Credit Card",
      joiningFee: "Nil",
      rewardsRate:
        "Earn 1 Reward Point for every Rs. 100 spent on retail purchases using the card, and enjoy 10 times the points on...",
      learnMoreLink: "/credit-card/aubank-credit-card",
      applyNowLink:
        "https://www.aubank.in/personal-banking/credit-cards/lit-credit-card",
    },
    {
      imageUrl: "/assets/easy.webp",
      title: "EazyDiner IndusInd  Credit Card",
      joiningFee: "Nil",
      rewardsRate:
        "Get rewarded with 2 Reward Points for every Rs. 100 spent, and earn double EazyPoints on all dining expenditures.",
      learnMoreLink: "/credit-card/eazy-diner-indusind-bank-credit-card",
      applyNowLink:
        "https://www.indusind.com/in/en/personal/cards/credit-card/eazydiner-credit-card.html",
    },
    {
      imageUrl: "/assets/hdfc.webp",
      title: "HDFC Bank Millennia Credit Card",
      joiningFee: "Rs. 1,000 + GST",
      rewardsRate:
        "Enjoy a 5% cashback in the form of CashPoints, when you shop at select online merchants, and receive a 1% cashback on all other purchases.",
      learnMoreLink: "/credit-card/hdfc-bank/millennia-credit-card",
      applyNowLink:
        "https://www.hdfcbank.com/personal/pay/cards/millennia-cards/millennia-cc-new",
    },
    {
      imageUrl: "/assets/SBI1.webp",
      title: "SBI SimplyCLICK Credit Card",
      joiningFee: "Rs. 499 + GST",
      rewardsRate:
        "Earn 10 times the Reward Points when you shop at partner brands such as BookMyShow and Apollo 24/7, and receive 5 times the Reward Points on other eligible purchases.",
      learnMoreLink: "/credit-card/sbi-simplyclick-credit-card",
      applyNowLink:
        "https://www.sbicard.com/en/personal/credit-cards/shopping/simplyclick-sbi-card.page",
    },
    {
      imageUrl: "/assets/Idfc1.webp",
      title: "IDFC FIRST Classic Credit Card",
      joiningFee: "Nil",
      rewardsRate:
        "With this card, earn 3 Reward Points for every Rs. 150 spent offline, 6 for every Rs. 150 spent online, and up to 10 Reward Points on monthly spends exceeding Rs. 20,000.",
      learnMoreLink: "/credit-card/idfcfirst-classic-credit-card",
      applyNowLink: "https://www.idfcfirstbank.com/credit-card/classic",
    },
    {
      imageUrl: "/assets/axis1.webp",
      title: " Flipkart Axis Bank Credit Card",
      joiningFee: "Rs. 500 + GST",
      rewardsRate:
        "Get a 5% cashback on purchases made on Flipkart, and enjoy a 4% cashback on transactions with preferred partners including Swiggy, Uber, PVR, and cult fit.",
      learnMoreLink: "/credit-card/axis-bank-flipkart-credit-card",
      applyNowLink:
        "https://www.axisbank.com/retail/cards/credit-card/flipkart-axisbank-credit-card",
    },
    // Add more card data objects here for additional cards
  ];

  const CreditFeature = [
    {
      icon: <FaTasks className="text-blue-500 text-5xl mb-4" />,
      title: "Credit Limit",
      description:
        "The maximum amount you can spend using the card. This limit is determined by the card issuer based on factors like income, credit history, and repayment capacity.",
    },
    {
      icon: <FaUsers className="text-blue-500 text-5xl mb-4" />,
      title: "Interest Rate (APR)",
      description:
        "The Annual Percentage Rate (APR) is the interest charged on unpaid balances. If you don’t clear your dues by the due date, the issuer will apply this interest. Different cards have varying interest rates, typically ranging from 30% to 45% annually.",
    },
    {
      icon: <FaChartLine className="text-blue-500 text-5xl mb-4" />,
      title: "Grace Period",
      description:
        "The time frame (usually 20–50 days) within which you can repay your balance without incurring interest charges. This allows responsible cardholders to avoid interest costs while benefiting from short-term credit.",
    },
    {
      icon: <FaGift className="text-blue-500 text-5xl mb-4" />,
      title: "Rewards & Benefits",
      description:
        "Many credit cards offer attractive rewards programs, including cashback, travel miles, discounts on shopping and dining, and exclusive perks like airport lounge access and concierge services.",
    },
    {
      icon: <FaCreditCard className="text-blue-500 text-5xl mb-4" />,
      title: "Minimum Payment Requirement",
      description:
        "If you’re unable to pay the full bill, you must at least make a minimum payment to avoid late fees and penalties. However, carrying forward unpaid balances results in interest accumulation.",
    },
    {
      icon: <FaShieldAlt className="text-blue-500 text-5xl mb-4" />,
      title: "Security & Fraud Protection",
      description:
        "Credit cards come with advanced security features such as chip-and-PIN technology, OTP authentication, and zero-liability protection in case of fraud or unauthorized transactions.",
    },
  ];

  const steps = [
    {
      title: "Making a Purchase",
      description:
        "You use your credit card by swiping, tapping, or entering card details online.",
    },
    {
      title: "Merchant Receives Payment",
      description:
        "Once approved, the card issuer transfers funds to the merchant, minus a small processing fee.",
    },
    {
      title: "Transaction Authorization",
      description:
        "The merchant sends transaction details to the payment processor, which forwards them to the credit card network.",
    },
    {
      title: "Verification by Card Issuer",
      description:
        "The card network contacts the card issuer (your bank) to check whether you have sufficient credit available and verify the transaction details.",
    },
    {
      title: "Approval or Decline",
      description:
        "If all details are correct and within your credit limit, the issuer approves the transaction, and the merchant gets confirmation. If not, the transaction is declined.",
    },
 
    {
      title: "Billing Statement",
      description:
        "The card issuer records your transactions and sends you a monthly statement detailing your outstanding balance, due date, and minimum payment required.",
    },
    {
      title: "Repayment",
      description:
        "You must repay the borrowed amount by the due date. You can either pay in full (to avoid interest) or make a minimum payment, with interest accruing on the remaining balance.",
    },
  ];

  const takeaways = [
    "Credit cards enable cashless transactions with a pay-later option.",
    "If you pay your full bill within the grace period, you avoid interest charges.",
    "Responsible usage improves your credit score, while late payments may lead to penalties and increased interest rates.",
  ];
  const points = [
    {
      title: "Financial Flexibility and Convenience",
      description: `A credit card allows you to make purchases anytime, even if you don’t have immediate cash on hand. Whether it’s an emergency expense, an online transaction, or booking travel tickets, a credit card ensures seamless transactions without the need to carry physical cash. Additionally, many credit cards come with easy EMI options, allowing users to convert large expenses into manageable monthly payments.`,
    },
    {
      title: "Builds and Improves Credit Score",
      description: `Using a credit card responsibly helps build a strong credit score, which is crucial when applying for loans, mortgages, or even rental agreements. Timely payments and responsible spending habits reflect positively on your credit history, improving your creditworthiness. A good credit score can help you secure loans with lower interest rates and better financial opportunities in the future.`,
    },
    {
      title: "Reward Points, Cashback, and Discounts",
      description: `Many credit cards offer rewards on purchases, including cashback, airline miles, and discounts on shopping, dining, and travel. By using a credit card strategically, you can save money and earn valuable perks. Some premium cards also provide exclusive benefits like free lounge access, concierge services, and special deals on entertainment and lifestyle purchases.`,
    },
    {
      title: "Enhanced Security and Fraud Protection",
      description: `Credit cards offer better security compared to debit cards and cash transactions. They come with fraud protection, zero liability on unauthorized transactions, and chargeback facilities in case of fraud or disputed transactions. Additionally, many credit cards provide virtual card numbers and OTP verification, ensuring safer online transactions.`,
    },
    {
      title: "Emergency Fund Access",
      description: `In times of financial emergencies, a credit card can be a lifesaver. Whether it's an unexpected medical bill, urgent travel expenses, or sudden repairs, a credit card provides instant access to funds when you need them the most. Some cards even offer features like cash withdrawal and emergency credit limit extensions to help during critical situations.`,
    },
  ];

  const points1 = [
    {
      title: "Shortlist Cards Based on Eligibility",
      description: `Start by determining which credit cards you qualify for based on your income and credit score. Entry-level cards are ideal for beginners and low-income earners, while premium cards cater to high-net-worth individuals with exclusive perks.`,
    },
    {
      title: "Identify Your Preferred Spending Category",
      description: `Choose a card that aligns with your lifestyle and spending habits. If you frequently travel, opt for a travel rewards card. If you shop online, look for cashback or e-commerce benefits. Selecting a card that suits your major spending category helps you maximize rewards.`,
    },
    {
      title: "Evaluate Features and Benefits",
      description: `Compare different cards by analyzing their features. Review the terms and conditions regarding rewards, cashback, redemption options, and spending limits. A thorough cost-benefit analysis ensures that you get the best value from your card.`,
    },
    {
      title: "Check Fees and Charges",
      description: `Credit cards come with varying fee structures. Entry-level cards usually have lower or no annual fees but offer basic perks, whereas mid-range and premium cards come with higher fees and exclusive benefits. Decide whether you prefer a no-fee card with limited benefits or a high-fee card with premium privileges.`,
    },
    {
      title: "Consider Interest Rates and Grace Periods",
      description: `If you plan to carry a balance, look for a card with a lower interest rate (APR). Also, check the grace period to understand how much time you have to pay off your balance before incurring interest charges.`,
    },
    {
      title: "Review Additional Perks and Protections",
      description: `Some credit cards offer extra benefits such as complimentary airport lounge access, travel insurance, fraud protection, and discounts on dining and entertainment. Choose a card that provides perks relevant to your needs.`,
    },
  ];

  const points2 = [
    {
      title: " Age",
      description: `Applicants must be at least 18 years old, with some banks requiring a minimum of 21 years. The upper limit usually ranges from 60 to 65 years. Younger applicants with limited credit history may qualify for student or secured credit cards. Age proof includes documents like a birth certificate, passport, or voter ID.`,
    },
    {
      title: "Income",
      description: `Banks assess income to determine an applicant’s repayment capacity. Higher-income levels increase the chances of approval for premium cards. Salaried individuals need salary slips or bank statements, while self-employed applicants must provide ITR and business documents.`,
    },
    {
      title: "Evaluate Features and Benefits",
      description: `Compare different cards by analyzing their features. Review the terms and conditions regarding rewards, cashback, redemption options, and spending limits. A thorough cost-benefit analysis ensures that you get the best value from your card.`,
    },
    {
      title: "Employment Status",
      description: `A stable job or business enhances creditworthiness. Salaried individuals need proof like salary slips or an appointment letter, while self-employed applicants must submit business registration and income proof.`,
    },
    {
      title: "Credit Score",
      description: `A credit score of 700+ is preferred, indicating responsible credit behavior. A higher score improves approval chances and may lead to better benefits. Timely repayments and low credit utilization help maintain a strong score.`,
    },
    {
      title: "Residential Status",
      description: `Banks require proof of residence, such as an Aadhaar card, passport, or utility bill. Stable residency enhances credibility, and some banks offer specific credit cards to NRIs with additional criteria.`,
    },
  ];
  const stats = [
    {
      title: 'Total Credit Cards in Circulation',
      description:
        'As of January 2025, there were approximately 109 million credit cards in circulation in India, marking a decrease of 1.2 million cards from the previous month.',
      icon: CreditCard,
    },
    {
      title: 'Credit Card Spending',
      description:
        'In January 2025, credit card spending reached ₹1.84 trillion, reflecting a 10.8% year-on-year increase. However, there was a slight decline compared to the previous month.',
      icon: TrendingUp,
    },
    {
      title: 'Average Spend per Card',
      description:
        'The average spending per credit card in January 2025 was ₹16,910, showing a 1.09% increase compared to the same period last year.',
      icon: Wallet,
    },
  ];
  return (
    <>
      <Helmet>
        <title>Compare & Apply Credit Cards Online for Instant Approval</title>
        <meta
          name="description"
          content="Credit Card - Get a Credit Card Approved Instantly from 50+ Top Banks in India. Compare Benefits, Offers, Features, Cashback & Rewards. Apply Card Now."
        />
        <meta
          name="keywords"
          content="best cash reward credit card, apply for gold card, amex credit card eligibility, hdfc credit card eligibility, aubank credit card, indusind eazydiner credit card, flipkart axis bank credit card apply"
        />
        <link rel="canonical" href="https://thefinmaster.com/credit-card" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
    
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500 ">Credit Card</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center overflow-hidden">
        {/* <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
                <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
                    Credit Card
                </h1>
                <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p> */}
        {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}
        {/* </div> */}

        {/* <div className='w-full h-full md:h-screen flex justify-center'>
        <div className='w-[95%] md:flex justify-center items-center '>
          <div className='w-full md:w-[40%] '>
            <h1 className='text-4xl md:text-5xl font-medium text-blue-600 text-center md:text-left mt-10 md:mt-0 '>Compare Credit Cards & Apply Now</h1>
            <p className='py-3 md:py-5 text-lg md:text-xl text-gray-600 text-center md:text-left'>explore credit cards now!</p>
            <button className='border rounded-full px-6 md:px-8 py-3 md:py-4 bg-blue-600 text-white '>Get Started</button>
          </div>
          <div className='w-full md:w-[60%]'>
            <img className='w-full h-[300px] md:h-[100%] object-cover' src='../assets/credit.jpeg' alt='demat growth' />
          </div>
        </div>
      </div> */}

        <div className="w-full flex flex-col items-center">
          <div className="w-full flex justify-center">
            <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
              <div className="w-full sm:w-[50%]">
                <div className="w-[90%]">
                  <h1 className="text-4xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                    <span className="text-blue-600  ">
                      Compare Credit Cards
                    </span>
                      & Apply Now!
                  </h1>

                  <p className="mt-4 text-gray-600 text-lg pl-6 lg:pl-0 md:pl-0  ">
                    Explore credit cards now!
                  </p>

                  {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
                </div>
              </div>
              <div className="w-full sm:w-[50%]">
                <motion.img
                  className="w-full max-w-full"
                  src="../assets/cc.png"
                  alt="car-loan"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className=" shadow-md rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-500 ho  border  ">
    <p className="text-lg md:text-xl lg:text-lg">
    In today's digital world, credit cards offer a powerful combination of convenience and financial rewards.  They allow you to make purchases without carrying cash, often extending a grace period before repayment is due. On top of that, many cards offer enticing rewards programs, returning a portion of your spending back to you in the form of cash back, travel points, or other benefits. However, it's crucial to use credit cards responsibly and pay your balance in full each month to avoid accumulating debt and high-interest charges.  
    </p>
    <p className="text-lg md:text-xl lg:text-lg">
    Here at TheFinMaster.com, we've compiled comprehensive lists to simplify your search and help you find the perfect credit card to unlock your financial potential.
    </p>
  </div> */}
        <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
          <p className="text-lg md:text-base lg:text-lg text-center">
            In today's fast-paced world, convenience reigns supreme. Credit
            cards offer a powerful solution, combining ease of use with the
            potential for valuable rewards. Forget carrying cash – swipe, tap,
            or pay online with just a few clicks. But the benefits go beyond
            convenience. Here at TheFinMaster.com, we'll guide you through the
            exciting world of credit cards
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
         

          <Link
            to="/credit-card/travel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdOutlineAirplanemodeActive className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Travel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-premium-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdStars className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Premium
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/lifestyle-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdCardMembership  className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
              LifeStyle
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/business-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaBriefcase className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
              Business 
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/reward-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdCardMembership  className="mr-4 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
              Reward
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-4 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          {/* <Link to="/premium_detail" state={CreditCardData ? CreditCardData?.cards : []} className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group">
<span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
<span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
<svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
</span>
<span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
<svg class="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
</span>
<span className="relative flex items-center"><MdStars className="mr-1 text-black text-2xl" /> <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">Premium</span></span>
</Link> */}
        </div>

        <h2 className="text-center text-2xl md:text-2xl lg:text-5xl font-bold my-10">
          Featured Credit Cards
        </h2>
        {/* <div className=" flex items-center justify-center">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 ">
            {cardDataS.map((card, index) => (
              <motion.div
                key={index}
                className="rounded-lg overflow-hidden shadow-lg border border-gray-200 max-w-xs"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <img className="w-full" src={card.imageUrl} alt={card.title} />
                <div className="px-3 py-2">
                  <div className="font-bold text-lg mb-1 text-center text-blue-500">
                    {card.title}
                  </div>
                  <p className="text-gray-600 text-base text-center mt-2">
                    <strong>Joining Fee:</strong> {card.joiningFee}
                  </p>
                  <p className="text-gray-600 text-base text-center mt-2">
                    <strong>Rewards Rate:</strong> {card.rewardsRate}
                  </p>
                </div>
                <div className="flex justify-center py-2">
                  <a
                    className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-1 px-3 rounded-full mr-2 text-sm transition duration-300 ease-in-out"
                    href={card.learnMoreLink}
                    target="blank"
                    rel="nofollow"
                  >
                    View Card
                  </a>
                  <a
                    className="bg-green-500 hover:bg-green-700 text-white font-medium py-1 px-3 rounded-full text-sm transition duration-300 ease-in-out"
                    href={card.applyNowLink}
                    target="blank"
                    rel="nofollow"
                  >
                    Apply Now
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div> */}

        <div className="flex flex-col lg:flex-row items-center justify-center gap-4 px-4 my-8">
  {/* Left Ad */}
  <div className="hidden lg:flex flex-shrink-0">
  <AdBanner displayOrder="1" />
  </div>

  {/* Card Grid */}
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    {cardDataS.map((card, index) => (
      <motion.div
        key={index}
        className="rounded-lg overflow-hidden shadow-lg border border-gray-200 max-w-xs"
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3 }}
      >
        <img className="w-full" src={card.imageUrl} alt={card.title} />
        <div className="px-3 py-2">
          <div className="font-bold text-lg mb-1 text-center text-blue-500">
            {card.title}
          </div>
          <p className="text-gray-600 text-base text-center mt-2">
            <strong>Joining Fee:</strong> {card.joiningFee}
          </p>
          <p className="text-gray-600 text-base text-center mt-2">
            <strong>Rewards Rate:</strong> {card.rewardsRate}
          </p>
        </div>
        <div className="flex justify-center py-2">
          <a
            className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-1 px-3 rounded-full mr-2 text-sm transition duration-300 ease-in-out"
            href={card.learnMoreLink}
            target="blank"
            rel="nofollow"
          >
            View Card
          </a>
          <a
            className="bg-green-500 hover:bg-green-700 text-white font-medium py-1 px-3 rounded-full text-sm transition duration-300 ease-in-out"
            href={card.applyNowLink}
            target="blank"
            rel="nofollow"
          >
            Apply Now
          </a>
        </div>
      </motion.div>
    ))}
  </div>

  {/* Right Ad */}
  <div className="hidden lg:flex flex-shrink-0">
  <AdBanner displayOrder="2" />
  </div>
</div>

        <div className="flex flex-col items-center justify-center mt-6">
          <h2 className="text-center text-2xl md:text-2xl lg:text-5xl font-bold mb-4">
            Discover Various Bank Credit Cards
          </h2>
          <p className="text-center text-lg md:text-xl lg:text-1xl ml-2">
            Tap on the bank logo below to discover the credit cards provided by
            each bank.
          </p>
        </div>
        <div className="flex flex-wrap justify-center mt-10  gap-4 md:grid md:grid-cols-2 lg:grid-cols-6">
          <Link to="/hdfc-bank/credit-card">
            <div className=" w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white  hover:bg-white rounded-lg shadow-2xl group">
              <img
                src="../assets/2.webp"
                alt="HDFC Bank"
                className=" object-contain mr-4 "
              />
            </div>
          </Link>
          <Link to="/axis-bank/credit-card">
            <div className=" w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white  hover:bg-white rounded-lg shadow-2xl group">
              <img
                src="../assets/1.webp"
                alt="AXIS Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>

          <Link to="/icici-bank/credit-card">
            <div className=" w-36  relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white  hover:bg-white rounded-lg shadow-2xl group">
              <img
                src="../assets/12.webp"
                alt="ICICI Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          {/* <Link to="/amex_detail">
      <div className=" w-32 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img src="/amex_logo.png" alt="AMEX" className=" object-contain mr-4" />
    </div>
    </Link> */}
          <Link to="/idfc-bank/credit-card">
            <div className=" w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/4.webp"
                alt="IDFC Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/sbi-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/3.webp"
                alt="SBI Card"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/induslnd-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/5.webp"
                alt="Indulnd Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/au-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/9.webp"
                alt="AU Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/bank-of-baroda/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/8.webp"
                alt="Baroda bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          {/* <Link to="/citi_detail" >
    <div className="w-32 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">        
        <img src="/au_logo.png" alt="Citi Bank" className=" object-contain mr-4" />
    </div>
    </Link> */}
          {/* <Link to="/fedral_detail"> 
    <div className="w-32 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">        
        <img src="/au_logo.png" alt="Fedral Bank" className=" object-contain mr-4" />
    </div>
    </Link> */}
          {/* <Link to="/kotak_detail" >
    <div className="w-32 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">        
        <img src="/au_logo.png" alt="Kotak Bank" className=" object-contain mr-4" />
    </div>
    </Link> */}
          <Link to="/american-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/ae.webp"
                alt="Rbl Bank"
                className="object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/hsbc-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/6.webp"
                alt="Sbi Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/standard-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/7.webp"
                alt="Standard Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
          <Link to="/yes-bank/credit-card">
            <div className="w-36 relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium z-0 transition-all duration-300 hover:scale-110 bg-white rounded-lg shadow-2xl hover:bg-white group">
              <img
                src="../assets/11.webp"
                alt="Yesbank Bank"
                className=" object-contain mr-4"
              />
            </div>
          </Link>
        </div>

        <div className="flex justify-center items-center  p-4 mt-6">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4"
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              What is a Credit Card?
            </h2>
            <p className="text-gray-600 leading-relaxed">
              A credit card is a financial instrument issued by banks and
              financial institutions that enables users to make purchases on
              credit. It allows cardholders to borrow funds up to a pre-approved
              limit to pay for goods and services at merchants that accept card
              payments.
            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
              Unlike a debit card, which deducts money directly from your bank
              account, a credit card provides a short-term loan, which must be
              repaid within a specified time. If the full repayment is not made
              by the due date, interest charges apply to the outstanding
              balance.
            </p>
          </motion.div>
        </div>

        <div className="flex flex-col justify-center items-center min-h-screen  p-4">
          <section id="features" className="py-6 w-full">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-bold text-center mb-8">
                Key Features of a Credit Card
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {CreditFeature.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="bg-white rounded-lg shadow-md p-6 text-center"
                  >
                    <div className="flex justify-center mb-2">
    {feature.icon}
  </div>
                    <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>
        </div>

        {/* <section
          id="comparison"
          aria-label="QuickEdit vs traditional editor"
          class="bg-slate-50 dark:bg-gray-800 py-10 sm:py-10"
        >
          <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="mx-auto max-w-2xl text-center">
              <h2 class="font-display text-3xl tracking-tight text-slate-900 dark:text-white sm:text-4xl">
                Statistics{" "}
              </h2>
              <p class="mt-4 text-lg tracking-tight text-slate-700 dark:text-gray-300">
                Discover the advantages of choosing QuickEdit over a traditional
                editor. Say goodbye to delays and elevate your content creation
                process.
              </p>
            </div>
            <ul
              role="list"
              class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:gap-8 lg:mt-20 lg:max-w-none lg:grid-cols-3"
            >
              <li>
                <ul role="list" class="flex flex-col gap-y-6 sm:gap-y-8">
                  <li>
                    <figure class="relative rounded-2xl bg-white dark:bg-gray-900 p-6 text-center shadow-xl shadow-slate-900/10">
                      <blockquote class="relative p-3">
                        <p class="text-lg font-bold tracking-tight text-slate-900 dark:text-white">
                          Total Credit Cards in Circulation
                        </p>
                      </blockquote>
                      <figcaption class="text-center">
                        <div class="font-display text-slate-900 dark:text-white">
                          As of January 2025, there were approximately 109
                          million credit cards in circulation in India, marking
                          a decrease of 1.2 million cards from the previous
                          month.{" "}
                        </div>
                      </figcaption>
                    </figure>
                  </li>
                </ul>
              </li>
              <li>
                <ul role="list" class="flex flex-col gap-y-6 sm:gap-y-8">
                  <li>
                    <figure class="relative rounded-2xl bg-white dark:bg-gray-900 p-6 text-center shadow-xl shadow-slate-900/10">
                      <blockquote class="relative p-3">
                        <p class="text-lg font-bold tracking-tight text-slate-900 dark:text-white">
                          Credit Card Spending
                        </p>
                      </blockquote>
                      <figcaption class="text-center">
                        <div class="font-display text-slate-900 dark:text-white">
                          In January 2025, credit card spending reached ₹1.84
                          trillion, reflecting a 10.8% year-on-year increase.
                          However, there was a slight decline compared to the
                          previous month.
                        </div>
                      </figcaption>
                    </figure>
                  </li>
                </ul>
              </li>
              <li>
                <ul role="list" class="flex flex-col gap-y-6 sm:gap-y-8">
                  <li>
                    <figure class="relative rounded-2xl bg-white dark:bg-gray-900 p-6 text-center shadow-xl shadow-slate-900/10">
                      <blockquote class="relative p-3">
                        <p class="text-lg font-bold tracking-tight text-slate-900 dark:text-white">
                          Average Spend per Card
                        </p>
                      </blockquote>
                      <figcaption class="text-center">
                        <div class="font-display text-slate-900 dark:text-white">
                          The average spending per credit card in January 2025
                          was ₹16,910, showing a 1.09% increase compared to the
                          same period last year.
                        </div>
                      </figcaption>
                    </figure>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </section> */}
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
        <section className="bg-gray-50 py-16 px-6 sm:px-8 lg:px-10">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Statistics</h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-12">
          Discover the advantages of choosing QuickEdit over a traditional editor. Say goodbye to delays and elevate your content creation process.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="bg-white shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300 rounded-2xl p-6 text-center flex flex-col items-center animate-fade-in"
              >
                <div className="bg-indigo-100 text-indigo-600 p-4 rounded-full mb-4 flex items-center justify-center">
                  <Icon className="w-8 h-8" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{stat.title}</h3>
                <p className="text-sm text-gray-600">{stat.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
        {/* <section class="bg-white ">
          <div class="max-w-9xl mx-auto p-4 sm:p-6 lg:p-8">
            <div class="container mx-auto px-6 p-6 bg-white">
              <div class="mb-10 text-center">
                <h4 class="text-base text-indigo-600 font-semibold tracking-wide uppercase">
                  Features
                </h4>
                <p class="mt-2 text-3xl lg:text-4xl font-bold tracking-tight text-gray-900">
                  How we change the game
                </p>
              </div>

              <div class="flex flex-wrap my-12">
                <div class="w-full border-b md:w-1/2 md:border-r lg:w-1/3 p-8">
                  <div class="flex items-center mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="h-6 w-6 text-indigo-500"
                    >
                      <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z"></path>
                    </svg>
                    <div class="ml-4 text-xl">Increase sales</div>
                  </div>
                  <p class="leading-loose text-gray-500">
                    Consectetur pariatur irure exercitation sit amet id
                    consectetur consecteturmagna et Lorem labore qui velit.
                  </p>
                </div>

                <div class="w-full border-b md:w-1/2 lg:w-1/3 lg:border-r p-8">
                  <div class="flex items-center mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="h-6 w-6 text-indigo-500"
                    >
                      <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z"></path>
                    </svg>
                    <div class="ml-4 text-xl">Enterprise-ready</div>
                  </div>
                  <p class="leading-loose text-gray-500">
                    Labore duis pariatur est exercitation laboris cupidatat amet
                    cillum. Amet nisi ullamco.
                  </p>
                </div>

                <div class="w-full border-b md:w-1/2 md:border-r lg:w-1/3 lg:border-r-0 p-8">
                  <div class="flex items-center mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="h-6 w-6 text-indigo-500"
                    >
                      <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z"></path>
                    </svg>
                    <div class="ml-4 text-xl">Unlimited growth</div>
                  </div>
                  <p class="leading-loose text-gray-500">
                    Elit deserunt nisi esse duis cupidatat proident sit minim
                    mollit officia pariatur incididunt in tempor.
                  </p>
                </div>

                <div class="w-full border-b md:w-1/2 lg:w-1/3 lg:border-r lg:border-b-0 p-8">
                  <div class="flex items-center mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="h-6 w-6 text-indigo-500"
                    >
                      <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z"></path>
                    </svg>
                    <div class="ml-4 text-xl">Recommended by experts</div>
                  </div>
                  <p class="leading-loose text-gray-500">
                    Velit sit tempor pariatur quis pariatur incididunt culpa
                    dolor voluptate officia incididunt velit dolore.
                  </p>
                </div>

                <div class="w-full border-b md:w-1/2 md:border-r md:border-b-0 lg:w-1/3 lg:border-b-0 p-8">
                  <div class="flex items-center mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="h-6 w-6 text-indigo-500"
                    >
                      <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z"></path>
                    </svg>
                    <div class="ml-4 text-xl">Modern platform</div>
                  </div>
                  <p class="leading-loose text-gray-500">
                    Laboris elit consectetur sint nisi eu mollit proident sit
                    magna velit adipisicing consequat amet reprehenderit.
                  </p>
                </div>

                <div class="w-full md:w-1/2 lg:w-1/3 p-8">
                  <div class="flex items-center mb-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="h-6 w-6 text-indigo-500"
                    >
                      <path d="M16 3C8.8 3 3 8.8 3 16s5.8 13 13 13 13-5.8 13-13c0-1.398-.188-2.793-.688-4.094L26.688 13.5c.2.8.313 1.602.313 2.5 0 6.102-4.898 11-11 11S5 22.102 5 16 9.898 5 16 5c3 0 5.695 1.195 7.594 3.094L25 6.688C22.7 4.386 19.5 3 16 3zm11.281 4.281L16 18.563l-4.281-4.282-1.438 1.438 5 5 .719.687.719-.687 12-12z"></path>
                    </svg>
                    <div class="ml-4 text-xl">Integrations</div>
                  </div>
                  <p class="leading-loose text-gray-500">
                    Nostrud excepteur incididunt proident sit nulla ipsum sunt
                    nostrud est esse adipisicing irure officia consectetur.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section class="overflow-hidden bg-white ">
          <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
              <div class="lg:pr-8 lg:pt-4">
                <div class="lg:max-w-lg">
                  {/* <h2 class="text-base font-semibold leading-7 text-indigo-600">Produce faster</h2> */}
                  <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                    How Does a Credit Card Work?
                  </p>
                  <p class="mt-4 text-lg leading-8 text-gray-600">
                    A credit card functions as a short-term loan, allowing you
                    to make purchases and pay later. Several key players are
                    involved in processing each transaction, ensuring a smooth
                    and secure payment experience.
                    <h2 class="mt-4 text-base font-semibold leading-7 text-blue-500">
                      Key Participants in a Credit Card Transaction:
                    </h2>
                  </p>
                  <dl class="mt-4 max-w-xl space-y-5 text-base leading-7 text-gray-600 lg:max-w-none">
                    <div class="relative pl-9">
                      <dt class="inline font-semibold text-gray-900">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                          class="absolute left-1 top-1 h-5 w-5 text-blue-500"
                        >
                          <path d="M3.196 12.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 12.87z"></path>
                          <path d="M3.196 8.87l-.825.483a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.758 0l7.25-4.25a.75.75 0 000-1.294l-.825-.484-5.666 3.322a2.25 2.25 0 01-2.276 0L3.196 8.87z"></path>
                          <path d="M10.38 1.103a.75.75 0 00-.76 0l-7.25 4.25a.75.75 0 000 1.294l7.25 4.25a.75.75 0 00.76 0l7.25-4.25a.75.75 0 000-1.294l-7.25-4.25z"></path>
                        </svg>
                        Cardholder (You)
                      </dt>
                      <dd class="inline">
                        The person using the credit card for purchases.
                      </dd>
                    </div>
                    <div class="relative pl-9">
                      <dt class="inline font-semibold text-gray-900">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                          class="absolute left-1 top-1 h-5 w-5 text-blue-500"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                        Merchant
                      </dt>
                      <dd class="inline">
                        The business or store where you make a transaction.
                      </dd>
                    </div>
                    <div class="relative pl-9">
                      <dt class="inline font-semibold text-gray-900">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                          class="absolute left-1 top-1 h-5 w-5 text-blue-500"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z"
                            clip-rule="evenodd"
                          ></path>
                          <path d="M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 01-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012zM6 4.586l2.33 2.33a.452.452 0 01-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 01-.447-.276l-1.7-3.402a.5.5 0 01.093-.577l.49-.49a.5.5 0 01.577-.094l3.402 1.7A.5.5 0 016 3.31v1.277z"></path>
                        </svg>
                        Card Issuer{" "}
                      </dt>
                      <dd class="inline">
                        The bank or financial institution that provides your
                        credit card, sets your credit limit, and determines your
                        interest rate.
                      </dd>
                    </div>
                    <div class="relative pl-9">
                      <dt class="inline font-semibold text-gray-900">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                          class="absolute left-1 top-1 h-5 w-5 text-blue-500"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z"
                            clip-rule="evenodd"
                          ></path>
                          <path d="M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 01-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012zM6 4.586l2.33 2.33a.452.452 0 01-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 01-.447-.276l-1.7-3.402a.5.5 0 01.093-.577l.49-.49a.5.5 0 01.577-.094l3.402 1.7A.5.5 0 016 3.31v1.277z"></path>
                        </svg>
                        Payment Processor{" "}
                      </dt>
                      <dd class="inline">
                        A company that facilitates electronic transactions
                        between merchants and banks.
                      </dd>
                    </div>
                    <div class="relative pl-9">
                      <dt class="inline font-semibold text-gray-900">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                          class="absolute left-1 top-1 h-5 w-5 text-blue-500"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M14.5 10a4.5 4.5 0 004.284-5.882c-.105-.324-.51-.391-.752-.15L15.34 6.66a.454.454 0 01-.493.11 3.01 3.01 0 01-1.618-1.616.455.455 0 01.11-.494l2.694-2.692c.24-.241.174-.647-.15-.752a4.5 4.5 0 00-5.873 4.575c.055.873-.128 1.808-.8 2.368l-7.23 6.024a2.724 2.724 0 103.837 3.837l6.024-7.23c.56-.672 1.495-.855 2.368-.8.096.007.193.01.291.01zM5 16a1 1 0 11-2 0 1 1 0 012 0z"
                            clip-rule="evenodd"
                          ></path>
                          <path d="M14.5 11.5c.173 0 .345-.007.514-.022l3.754 3.754a2.5 2.5 0 01-3.536 3.536l-4.41-4.41 2.172-2.607c.052-.063.147-.138.342-.196.202-.06.469-.087.777-.067.128.008.257.012.387.012zM6 4.586l2.33 2.33a.452.452 0 01-.08.09L6.8 8.214 4.586 6H3.309a.5.5 0 01-.447-.276l-1.7-3.402a.5.5 0 01.093-.577l.49-.49a.5.5 0 01.577-.094l3.402 1.7A.5.5 0 016 3.31v1.277z"></path>
                        </svg>
                        Credit Card Networks
                      </dt>
                      <dd class="inline">
                        Global payment networks like Visa, Mastercard, and Rupay
                        that ensure seamless communication between all parties.
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
              <img
                src="/assets/ccc.png"
                alt="NoImage"
                class="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
                width="2432"
                height="1442"
              />
            </div>
          </div>
        </section>

        {/* <div className="min-h-screen p-6 flex flex-col items-center mt-6">
          <h1 className="text-3xl font-bold mb-6 text-center">
            Step-by-Step Credit Card Transaction Process
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-7xl px-4">
            {steps.map((step, index) => (
              <div
                key={index}
                className="bg-white p-4 rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300"
              >
                <h2 className="text-xl font-semibold mb-2">{step.title}</h2>
                <p className="text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>

          <div className="bg-blue-500 text-white p-6 rounded-lg mt-10 w-full max-w-7xl">
            <h2 className="text-2xl font-bold mb-4">Key Takeaways</h2>
            <ul className="list-disc pl-6">
              {takeaways.map((point, index) => (
                <li key={index} className="mb-2">
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div> */}
<div className="min-h-screen p-6 flex flex-col items-center mt-6 bg-gray-50">
  <h3 className="text-3xl font-bold mb-6 text-center">
    Step-by-Step Credit Card Transaction Process
  </h3>

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-7xl px-4">
    {steps.map((step, index) => (
      <div
        key={index}
        className="bg-white p-6 rounded-2xl shadow-lg transition duration-300 transform hover:scale-105 hover:shadow-indigo-200 hover:shadow-2xl hover:border hover:border-indigo-300 border border-transparent text-center"
      >
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 text-indigo-600 text-lg font-bold mx-auto mb-4">
          {index + 1}
        </div>
        <h2 className="text-xl font-semibold mb-2">{step.title}</h2>
        <p className="text-gray-600">{step.description}</p>
      </div>
    ))}
  </div>
</div>
<div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="4" />
  </div>
</div>
        <div className=" px-2 md:px-6 bg-gray-100">
          <div className=" p-6 min-h-screen">
            <h3 className="text-3xl font-bold text-blue-700 mb-4">
              Why Do We Need a Credit Card?
            </h3>
            <p className="text-gray-700 mb-6">
              Credit cards are more than just a convenient way to make
              payments—they offer financial flexibility, security, and a range
              of benefits that can help in everyday transactions. Here are five
              key reasons why having a credit card is essential:{" "}
            </p>

            {points.map((point, index) => (
              <div
                key={index}
                className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
              >
                <h2 className="text-xl font-semibold text-blue-600">
                  {point.title}
                </h2>
                <p className="text-gray-600">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      
        <div className=" px-2 md:px-6 bg-gray-100">
          <div className=" p-6 min-h-screen">
            <h2 className="text-3xl font-bold text-blue-700 mb-4">
              How to Choose the Right Credit Card?
            </h2>
            <p className="text-gray-700 mb-6">
              Selecting the right credit card is crucial for maximizing benefits
              and managing your finances effectively. Here are key factors to
              consider when choosing a credit card:
            </p>

            {points1.map((point, index) => (
              <div
                key={index}
                className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
              >
                <h2 className="text-xl font-semibold text-blue-600">
                  {point.title}
                </h2>
                <p className="text-gray-600">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
        <div className=" px-2 md:px-6 bg-gray-100">
          <div className=" p-6 min-h-screen">
            <h2 className="text-3xl font-bold text-blue-700 mb-4">
              Factors affecting the Credit Card
            </h2>
            {/* <p className="text-gray-700 mb-6">
            Selecting the right credit card is crucial for maximizing benefits and managing your finances effectively. Here are key factors to consider when choosing a credit card:
            </p> */}

            {points2.map((point, index) => (
              <div
                key={index}
                className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
              >
                <h2 className="text-xl font-semibold text-blue-600">
                  {point.title}
                </h2>
                <p className="text-gray-600">{point.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 
            <div className='w-[95%] py-10'>
                <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                <AccordionComponent />
            </div> */}
      </div>
      <div className="max-w-4xl mx-auto py-6 mt-6 px-2">
        <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CreditCardPage;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link } from 'react-router-dom'
// const CreditCardPage = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);

//     useEffect(()=>{
//         Http.post(CARD_API).then((res)=>{
//             setCreditCardData(res)
//         }).catch((err)=>{
//             console.log(err)
//         })
//     },[])
//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     console.log({indexOfLastCard,indexOfFirstCard})
//     const currentCards = CreditCardData.cards?.filter((card)=>card.category==="Credit card").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     Credit Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default CreditCardPage
